//////////////////////////////////////////////////////////////////////////////
//
//  Authentication API
//
//  작성자: MyungHwan Kim
//  생성일: 2025-10-24
//
//  설명: 인증 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 인증 관련 API
 */
const AuthenticationAPI: ApiGroup = {
  login: {
    title: "로그인",
    url: "/Authentication/login",
    method: "POST",
    paramz: {},
  },
}

export default AuthenticationAPI
